
import { getCurrentDriverStatus } from "../../../utils/utils";
import {
  getClockedInDriverStatusLabel,
  getNotClockedInDriverLabel,
  getNotClockedInDriverStatus,
  isDriverTimeBeforeCurrentDateAndTime,
} from "..";
import {
  ALL_DRIVER_STATUS,
  DRIVER_EVENTS,
  DRIVER_LOGGED_STATUS,
} from "../../constants";

const getDriverStatusEvent = (props) => {
  if (
    !props.data.dispatchId &&
    props?.data?.loggedInStatus !== DRIVER_LOGGED_STATUS.loggedIn
  ) {
    if (isDriverTimeBeforeCurrentDateAndTime(props.data.driverClockedInTime)) {
      return ALL_DRIVER_STATUS.DriverClockedIn;
    } else {
      return getNotClockedInDriverStatus(
        props.data.scheduleTime,
        props.context.terminalOffset
      );
    }
  }

  if (
    props.data.currentStatus &&
    [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      props.data.currentStatus.status
    )
  ) {
    return props.data.currentStatus.status;
  }

  if (!props.data.routeId && props.data.dispatchId) {
    return props.data.driverStatus;
  }
  
  return props.data.routeStatus;
};

const getDriverStatusLabel = (props, driverStatus) => {
  switch (driverStatus) {
    case ALL_DRIVER_STATUS.EnrouteToStop:
    case ALL_DRIVER_STATUS.ArrivedAtStop:
      return getCurrentDriverStatus({
        currentStatus: props.data.currentStatus,
        stops: props.data.stops,
      });
    case ALL_DRIVER_STATUS.DriverClockedIn:
      return getClockedInDriverStatusLabel(props.data.driverClockedInTime, props.data.driverClockedInDept);
    case ALL_DRIVER_STATUS.DueTime:
    case ALL_DRIVER_STATUS.LateBy:
      return getNotClockedInDriverLabel(
        props.data.scheduleTime,
        props.context.terminalOffset
      );
    default:
      return driverStatus;
  }
};

export const getDriverStatus = (props, onlyLabel = true) => {
  const driverStatus = getDriverStatusEvent(props);
  const driverStatusLabel = getDriverStatusLabel(props, driverStatus);

  if (onlyLabel) {
    return driverStatusLabel;
  }
  return {
    driverStatus,
    driverStatusLabel,
  };
};
